/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.4.26",
    versionName: "0.2.0-nightly.2026.4.26",
    versionChannel: "nightly",
    buildDate: "2026-04-26T00:17:20.498Z",
    commitHash: "b7784e819f29401cee2b19a011e89e4b128495e4",
};
